import { render, staticRenderFns } from "./ScientificDegreeUpdate.vue?vue&type=template&id=10349a24&"
import script from "./ScientificDegreeUpdate.vue?vue&type=script&lang=js&"
export * from "./ScientificDegreeUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports